// @flow

import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga4';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

import './expedition.css';
import App from './app';
import { isProd } from './util/config';
import history from './util/history';
import { unregister } from './registerServiceWorker';
import './i18n';

import { initKlaviyo } from './util/klaviyo-init';
import { initFBEvents, initFBSdk } from './util/facebook-init';

if (isProd) {
  Sentry.init({
    dsn: 'https://2a4c2619fe7a4810af4cc011f486b49d@sentry.io/282776',
    integrations: [
      new Integrations.ExtraErrorData(),
    ],
  });
}

/**
 * Do not remove these. They appear to be unused in this codebase,
 * but simply by installing the sdk and events FB is tracking URL routes,
 * which we use for FB conversion metrics
 */
initFBEvents();
initFBSdk();

initKlaviyo();

ReactGA.initialize(isProd ? 'G-PTH9LYX43V' : 'G-59QK6W53JZ');
history.listen((location) => {
  ReactGA.set({ page: location.pathname });
  ReactGA.send({
    hitType: 'pageview',
    page: location.pathname,
  });
});

const root = document.getElementById('root');
if (!root) {
  throw Error('Could not find root element');
}
ReactDOM.render(<App />, root);
unregister();
